module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.modalId,
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.modalState) + "  \n          "), (_vm.state == 3 && !_vm.editState && _vm.optionInfo.is_mandatory) ? _c('label', {
    staticClass: "badge bg-red"
  }, [_vm._v("必選")]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.optionInfo.is_common) ? _c('label', {
    staticClass: "badge bg-blue"
  }, [_vm._v("常見")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(_vm.editState) ? _c('button', {
    staticClass: "btn btn-danger icon-modal-del",
    on: {
      "click": function($event) {
        _vm.show.delNotify = !_vm.show.delNotify
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editState && _vm.state == 3) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.delNotify) ? _c('div', {
    staticClass: "del-c-block"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show.delNotify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delOption
    }
  }, [_vm._v("刪除")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.state == 3 && !_vm.editState) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分類")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.sub_type))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選項名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.getSubType(_vm.optionInfo.name)))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排序")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.sort))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("購買數")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.min_limit) + " ～ " + _vm._s(_vm.maxAmount(_vm.optionInfo.max_limit)))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("$" + _vm._s(_vm.optionInfo.price) + " (" + _vm._s(_vm.getPriceType(_vm.optionInfo.price_type)) + ")")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.optionInfo.calorie) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.calorie) + " cal")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.optionInfo.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.description))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.optionInfo.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.remark))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.optionInfo.option_custom_id) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("POS廠自定義的ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.option_custom_id))])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 1 || _vm.editState) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sub_type),
      expression: "optionInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.optionList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.name),
      expression: "optionInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.optionInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sort),
      expression: "optionInfo.sort"
    }],
    ref: "sort1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.optionInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "sort", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sort),
      expression: "optionInfo.sort"
    }],
    ref: "sort3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.optionInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "sort", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_mandatory, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_mandatory, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_common, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_common, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.min_limit),
      expression: "optionInfo.min_limit"
    }],
    ref: "minLimit1",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "min_limit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.min_limit),
      expression: "optionInfo.min_limit"
    }],
    ref: "minLimit3",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "min_limit", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.max_limit),
      expression: "optionInfo.max_limit"
    }],
    ref: "maxLimit1",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "max_limit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.max_limit),
      expression: "optionInfo.max_limit"
    }],
    ref: "maxLimit3",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "max_limit", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price),
      expression: "optionInfo.price"
    }],
    ref: "price1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "price", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price),
      expression: "optionInfo.price"
    }],
    ref: "price3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "price", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price_type),
      expression: "optionInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(若無價格則無須更動)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.calorie),
      expression: "optionInfo.calorie"
    }],
    ref: "calorie1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.optionInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "calorie", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.calorie),
      expression: "optionInfo.calorie"
    }],
    ref: "calorie3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.optionInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "calorie", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.description),
      expression: "optionInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.remark),
      expression: "optionInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("POS廠自定義的ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.option_custom_id),
      expression: "optionInfo.option_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.optionInfo.option_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "option_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (_vm.state != 3 || _vm.editState) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.state == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("編輯")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-left"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('p', [_vm._v("確定刪除此商品？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選項名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("最低選擇項目個數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("最高選擇項目個數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f3b850"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/OptionModal.vue
// module id = 2303
// module chunks = 1